/* eslint-disable import/no-cycle */
import { format } from 'numerable';
import getColumnForIMOAction from 'src/pages/analytics/simulator/common/features/table/components/imo-action-column-component';
import { InputType, TableComponent } from '../../types/generic-table.model';
import { extractValue, formatNumberUsingRegex } from '../../utils/number-utils';
import { CircularProgress } from '@mui/material';

export default function DisplayCell({
  columnMetadata,
  value,
  colorCode = false,
  rowData
}: {
  columnMetadata: any;
  value: number;
  colorCode: boolean;
  // eslint-disable-next-line react/require-default-props
  rowData?: unknown;
  }) {

  // checking for action column for IMO
  if (columnMetadata.parent.field_format === InputType.OVERWRITE) {
    return getColumnForIMOAction(
      TableComponent.INNOVATION,
      columnMetadata,
      rowData
    );
  }
  if (
    columnMetadata.parent.field_format !== InputType.OVERWRITE &&
    typeof value !== 'number'
  ) {
    // console.warn(`Received invalid value ${value}`);
    return <span />;
  }
  if (
    columnMetadata.parent.field_format === InputType.PRICE_THRESHOLD_TYPE
  ) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center'
      }}>
        <CircularProgress
          size={20}
          sx={{ color: '#FD7622' }}
          variant='determinate'
          value={value}
        />
        <div>{value} %</div>
      </div>
    );
  }
  let numValue = value.toString();
  if (columnMetadata.number_format) {
    try {
      numValue = format(
        value,
        columnMetadata.number_format.replaceAll('#', '0'),
        {
          zeroFormat: '0'
        }
      );
    } catch {
      console.error(
        `Could not format number ${value} using pattern ${columnMetadata.parent.number_format}`
      );
    }
  }

  // getting the value to be displayed on cells
  const displayValue = extractValue(
    formatNumberUsingRegex(columnMetadata, +numValue)
  );

const regexFormattedValue = columnMetadata && columnMetadata.parent.number_format
    ? formatNumberUsingRegex(columnMetadata, +numValue).replace(
        // Preserve negative sign if present and avoid removing it for values like zero
        /^(-)?([^0-9]*)(0+(\.[0-9]+)?)(.+)?$/,
        (_, sign = '', prefix = '', zeros = '', _dec = '', suffix = '') => {
          // If numeric value is zero or negative zero, remove the minus sign to show just '0'
          if (+numValue === 0) {
            return `${prefix}${zeros}${suffix}`;
          }
          return `${sign}${prefix}${zeros}${suffix}`;
        }
      )
    : numValue;
  return (
    <span
      style={
        colorCode
          ? {
              color:
                displayValue > 0
                  ? '#44AB6F'
                  : displayValue < 0
                  ? '#EC3225'
                  : '#525252'
            }
          : {}
      }
    >
      {/* removing extra minus sign in case of zero values and rest maintaining the format */}
        {regexFormattedValue}
    </span>
  );
}
